import urlPrefix from "./apiPrefix";

export const getLotteryTicketCount = () => `${urlPrefix.value}/tax-web-control/api/lottery/ticket/count`;
